import { render } from "./ServiceListRiver.vue?vue&type=template&id=2f1dd15b&scoped=true"
import script from "./ServiceListRiver.vue?vue&type=script&lang=js"
export * from "./ServiceListRiver.vue?vue&type=script&lang=js"

import "./ServiceListRiver.vue?vue&type=style&index=0&id=2f1dd15b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1dd15b"]])

export default __exports__